module.exports = __webpack_public_path__ + "static/shambling_mound-8f499931f2bd9c2bf4567feac6e90c08.jpeg";